import { useAuth } from '@frontegg/react';
import { Modal } from 'antd';
import { analytics } from 'src/services';

function UpgradeSuccessModal({ open, onCancel }) {
  const { user } = useAuth();

  const handleCancel = () => {
    // eslint-disable-next-line no-undef
    analytics.track(
      'Clicked Explore Pro Features In Pro Trial Upgrade Success Modal',
      {
        email: user?.email,
      }
    );
    onCancel?.();
  };

  return (
    <Modal
      open={open}
      className="p-8"
      onCancel={onCancel}
      footer={
        <div className="flex justify-center">
          <button className="ih-button-primary" onClick={handleCancel}>
            Explore pro features
          </button>
        </div>
      }
      centered
    >
      <div className="flex flex-col items-center text-center gap-4 mb-6">
        <div className="flex flex-col items-center p-6 text-5xl">🎉</div>
        <div className="text-2xl font-semibold">Congratulations!</div>
        <div>
          <div className="text-sm text-gray-500">
            Your 30-day free pro trial is now active.
          </div>
          <div className="text-sm text-gray-500">
            Enjoy enhanced features and capabilities!
          </div>
        </div>
      </div>
    </Modal>
  );
}

export { UpgradeSuccessModal };
